export const version = "placeholder-version"; // will be overwritten by jenkins
//# sourceMappingURL=version.js.map